import { showWorthWatchingTooltipIfNotSeen } from './showWorthWatchingTooltipIfNotSeen';
import { showPauseAnimation } from './showPauseAnimation';
import { Store } from '../../../store/player/types';

/**
 * Pause the recording.
 *
 * @param {Store} store
 * @param {boolean} showAnimation show the pause animation in the middle of the screen
 * @param {boolean} [manualPause=true] show floating buttons above current timeline position indicator
 */
export const pause = (store: Store, showAnimation = false, manualPause = true): void => {
  const { playbackScript, playTimeoutId, done, setManuallyPausedOnce, setPlaying } =
    store.getState();

  if (!done) {
    showWorthWatchingTooltipIfNotSeen(store);
  }

  setPlaying(false);
  setManuallyPausedOnce(manualPause);

  clearTimeout(playTimeoutId as number);

  playbackScript.pause();

  if (showAnimation) {
    showPauseAnimation();
  }
};
